import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { projectApiStore, identifierSaveStore, appStore } from "@/hooks";
import { Modal, TextInput, TextButton } from "@/components/common";


/**
 * A modal for confirming project deletion.
 */
const __default__ = {
  name: "DeleteProjectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const confirmText = ref("");

const open = computed(() => appStore.popups.deleteProject);
const projectName = computed(
  () => identifierSaveStore.baseIdentifier?.name || ""
);
const label = computed(() => `Type "${projectName.value}"`);
const canDelete = computed(() => confirmText.value === projectName.value);

/**
 * Clears the modal data and closes the modal.
 */
function handleClose(): void {
  confirmText.value = "";
  appStore.close("deleteProject");
}

/**
 * Confirms the project deletion.
 */
function handleConfirm(): void {
  projectApiStore.handleDelete({
    onSuccess: handleClose,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    loading: _unref(projectApiStore).deleteProjectLoading,
    open: open.value,
    title: "Delete Project",
    subtitle: "Are you sure you want to delete this project? Type in the project's name to confirm deletion.",
    "data-cy": "modal-project-delete",
    onClose: handleClose
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        color: "negative",
        label: "Delete",
        disabled: !canDelete.value,
        loading: _unref(projectApiStore).deleteProjectLoading,
        "data-cy": "button-project-delete",
        onClick: handleConfirm
      }, null, 8, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TextInput), {
        modelValue: confirmText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((confirmText).value = $event)),
        label: label.value,
        "data-cy": "input-project-delete-name"
      }, null, 8, ["modelValue", "label"])
    ]),
    _: 1
  }, 8, ["loading", "open"]))
}
}

})